export default{
    clearCache() {
        window.localStorage.removeItem('subLadeOpMaatCatInfo');
        window.localStorage.removeItem('subLadeOpMaatCat');
        window.localStorage.removeItem('catLadeOpMaatDetail');
        window.localStorage.removeItem('preSteps');
        window.localStorage.removeItem('steps');
        window.localStorage.removeItem('currentStep');
        window.localStorage.removeItem('totalprice');

        window.localStorage.removeItem('selectedBrand');
        window.localStorage.removeItem('step1HeightproductID');
        window.localStorage.removeItem('step1Height');
        window.localStorage.removeItem('step1TypeProductID');
        window.localStorage.removeItem('step1Type');
        window.localStorage.removeItem('step1Brand');
        window.localStorage.removeItem('step1productID');
        location.reload(true);
        //window.location.href
    },
    nextStep(n) {
        if (n === this.steps) {
            this.currentStep = 1
        } else {
            this.currentStep = n + 1
        }
        localStorage.currentStep = this.currentStep;
    },
    prevStep(n) {
        if (n > this.steps) {
            this.currentStep = 1
        } else {
            this.currentStep = n - 1
        }
        localStorage.currentStep = this.currentStep;
    },
    onCartAdd() {
        this.duoHeaderCartItems.qty = this.duoHeaderCartItems.qty + 1;
        this.duoHeaderCartItems.value = this.duoHeaderCartItems.value + 25;
        this.snackbar = "true";
        this.currentStep = 1
    }
}
